import AccountScreen from './AccountScreen'
export default AccountScreen
